'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var button = require('./button-c50f4784.js');

var buttonContainerStyles = {
    reverse: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    padding: 16px 24px 8px;\n    border-top: 1px solid ", ";\n  "], ["\n    padding: 16px 24px 8px;\n    border-top: 1px solid ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.palette.systemGreyLight;
    }),
    clearButton: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    padding: 2px 16px;\n  "], ["\n    padding: 2px 16px;\n  "]))),
    default: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    padding: 16px;\n  "], ["\n    padding: 16px;\n  "]))),
};
var Container = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n  justify-content: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n  justify-content: ", ";\n"])), function (_a) {
    var buttonType = _a.buttonType;
    return buttonContainerStyles[buttonType];
}, function (_a) {
    var isRightButtons = _a.isRightButtons;
    return (isRightButtons ? 'flex-end' : 'flex-start');
});
var FilterButton = styled__default(button.Button)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var showClearButton = _a.showClearButton;
    return (showClearButton ? '4px 4px' : '4px 16px');
});
var FilterButtons = function (_a) {
    var _b = _a.submitButtonText, submitButtonText = _b === void 0 ? 'Filter' : _b, _c = _a.resetButtonText, resetButtonText = _c === void 0 ? 'Reset' : _c, onSubmit = _a.onSubmit, onReset = _a.onReset, disabled = _a.disabled, _d = _a.isRightButtons, isRightButtons = _d === void 0 ? false : _d, showClearButton = _a.showClearButton, _e = _a.reverseBottomButtons, reverseBottomButtons = _e === void 0 ? false : _e, _f = _a.submitButtonVariant, submitButtonVariant = _f === void 0 ? 'primary' : _f, rest = tslib_es6.__rest(_a, ["submitButtonText", "resetButtonText", "onSubmit", "onReset", "disabled", "isRightButtons", "showClearButton", "reverseBottomButtons", "submitButtonVariant"]);
    var buttonType;
    if (reverseBottomButtons) {
        buttonType = 'reverse';
    }
    else if (showClearButton) {
        buttonType = 'clearButton';
    }
    else {
        buttonType = 'default';
    }
    return (React__default.createElement(Container, tslib_es6.__assign({ "data-testid": "filter-buttons", isRightButtons: isRightButtons, buttonType: buttonType }, rest),
        reverseBottomButtons && (React__default.createElement(FilterButton, { showClearButton: showClearButton, variant: "cancelButton", text: resetButtonText, onClick: onReset })),
        showClearButton ? null : (React__default.createElement(FilterButton, { text: submitButtonText, variant: submitButtonVariant, onClick: onSubmit, disabled: disabled })),
        !reverseBottomButtons && (React__default.createElement(FilterButton, { showClearButton: showClearButton, variant: "cancelButton", text: resetButtonText, onClick: onReset }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.FilterButtons = FilterButtons;
